<!-- <body data-front-url="{{frontUrl}}">  -->

<!-- Header -->
<header class="header header2">
  <div class="container">
    <div class="offcanvas-info">
      <div class="offcanvas-wrap">
        <div class="offcanvas-detail">
          <div class="offcanvas-head d-flex justify-content-between align-items-center mb-3">
            <a href="public/index.html">
              <img
                src="assets/layout/assets/img/logo-small.webp"
                alt="logo-img"
                style="max-width: 4rem"
              />
            </a>
            <div class="offcanvas-close">
              <i class="ti ti-x"></i>
            </div>
          </div>
          <div class="mobile-menu fix mb-3"></div>
          <div class="offcanvas__contact">
            <div class="mt-4">
              <a
                href="javascript:void(0);"
                class="btn btn-secondary rounded btn-sm align-items-center me-1"
              >
                <i class="isax isax-magicpen5 text-white me-2"></i>Request Demo
                <i class="ti ti-arrow-right ms-1"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="btn btn-primary-gradient rounded btn-sm align-items-center"
              >
                <i class="isax isax-magicpen5 text-white me-2"></i>Request Demo
                <i class="ti ti-arrow-right ms-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas-overlay"></div>
    <div class="header-nav">
      <div class="main-menu-wrapper">
        <div class="navbar-logo">
          <a class="logo-link header-logo" href="#home">
            <img
              src="assets/layout/assets/img/logo-small.webp"
              class="logo logo-display"
              alt="Logo"
              style="max-width: 4rem"
            />
          </a>
        </div>
        <nav id="mobile-menu">
          <ul class="main-nav">
            <li class="nav-item">
              <a class="nav-link" href="#features">Features</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#pricing">Pricing</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#reviews">Reviews</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contactus">Contact us</a>
            </li>
          </ul>
        </nav>
        <div class="header-btn d-flex align-items-center">
          <!-- <a
                href='javascript:void(0);'
                class='btn btn-secondary rounded btn-sm align-items-center'
              >
                <i class='isax isax-magicpen5 text-white me-2'></i>Request Demo
                <i class='ti ti-arrow-right ms-1'></i>
              </a>  -->
          <a href="#freeTrial" class="btn btn-primary-gradient rounded btn-sm align-items-center">
            <i class="isax isax-magicpen5 text-white me-2"></i>Request Demo
            <i class="ti ti-arrow-right ms-1"></i>
          </a>
          <div class="header__hamburger d-xl-none my-auto">
            <div class="sidebar-menu">
              <i class="ti ti-menu-deep text-primary fs-25"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<!-- /Header -->

<div
  data-bs-spy="scroll"
  data-bs-target="#scroll-nav"
  data-bs-offset="0"
  class="scrollspy-example"
  tabindex="0"
>
  <router-outlet></router-outlet>

  <!-- Footer -->
  <footer class="footer-one footer-two">
    <img
      src="assets/layout/assets/img/bg/topology-3.png"
      alt="img"
      class="d-none d-lg-flex footer-bg"
    />
    <img
      src="assets/layout/assets/img/bg/topology-4.png"
      alt="img"
      class="d-none d-lg-flex footer-bg2"
    />
    <div class="container">
      <div class="footer-top row align-items-center row-gap-3">
        <div class="col-md-4" data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <span>
            <img src="assets/layout/assets/img/logo-small.webp" alt="" style="max-width: 4rem" />
          </span>
          <p class="my-4">
            Prepare your HR department for the future with our adaptable HRMS, designed to meet the
            needs of a dynamic workplace and foster a culture of continuous improvement.
          </p>
          <!-- <div class='footer-icon d-flex align-items-center'>
                <a href='javascript:void(0);' class='avatar avatar-md rounded-circle me-2'><i
                    class='ti ti-brand-facebook fs-16'
                  ></i></a>
                <a href='javascript:void(0);' class='avatar avatar-md rounded-circle me-2'><i
                    class='ti ti-brand-x fs-16'
                  ></i></a>
                <a href='javascript:void(0);' class='avatar avatar-md rounded-circle me-2'><i
                    class='ti ti-brand-instagram fs-16'
                  ></i></a>
                <a href='javascript:void(0);' class='avatar avatar-md rounded-circle me-2'><i
                    class='ti ti-brand-linkedin fs-16'
                  ></i></a>
                <a href='javascript:void(0);' class='avatar avatar-md rounded-circle'><i
                    class='ti ti-brand-pinterest fs-16'
                  ></i></a>
              </div> -->
        </div>
        <div class="col-md-8">
          <div
            class="footer-links row row-gap-3"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1000"
            data-aos-once="true"
          >
            <div class="col-md-3 col-sm-3">
              <h5 class="text-gray-9">Useful Pages</h5>
              <ul>
                <!--  <li><a href='javascript:void(0);'>Products</a></li>  -->
                <li><a href="#features">Features</a></li>
                <!--  <li><a href='javascript:void(0);'>Integrations</a></li>  -->
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="javascript:void(0);">Contact</a></li>
              </ul>
            </div>
            <div
              class="col-md-3 col-sm-3"
              data-aos="fade-up"
              data-aos-delay="350"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <h5 class="text-gray-9">Company</h5>
              <ul>
                <!--<li><a href='javascript:void(0);'>About</a></li> 
                     <li><a href='javascript:void(0);'>Blogs</a></li> 
                    <li><a href='javascript:void(0);'>Blogs Details</a></li> 
                     <li><a href='javascript:void(0);'>Testimonials</a></li>  -->
                <li><a href="/auth/login">Log In</a></li>
              </ul>
            </div>
            <div
              class="col-md-3 col-sm-3"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <!-- <h5 class='text-gray-9'>Quick Links</h5>
                  <ul>
                    <li><a href='javascript:void(0);'>Services</a></li>
                    <li><a href='javascript:void(0);'>Careers</a></li>
                    <li><a href='javascript:void(0);'>Clients</a></li>
                    <li><a href='javascript:void(0);'>Resources</a></li>
                    <li><a href='javascript:void(0);'>Enquiry </a> </li>
                  </ul> -->
            </div>
            <div
              class="col-md-3 col-sm-3"
              data-aos="fade-up"
              data-aos-delay="450"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <h5 class="text-gray-9">Modules</h5>
              <ul>
                <!-- <li><a href='javascript:void(0);'>Payment gateways</a></li>
                     <li><a href='javascript:void(0);'>Applications</a></li> 
                     <li><a href='javascript:void(0);'>Management</a></li> 
                     <li><a href='javascript:void(0);'>FAQ</a></li>  -->
                <li><a href="#features">Features</a></li>
                <li>
                  <a href="javascript:void(0);" data-activate-tab="calendar-tab">Calendar</a>
                </li>
                <li>
                  <a href="javascript:void(0);" data-activate-tab="payroll-tab">Payroll</a>
                </li>
                <li><a href="javascript:void(0);" data-activate-tab="events-tab">Events</a></li>
                <li>
                  <a href="javascript:void(0);" data-activate-tab="admin-tab">SuperAdmin</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row justify-content-between align-items-center flex-wrap row-gap-3">
          <div class="col-md-6">
            <p class="copy-right text-gray-9">
              Copyright {{ previousYear }}-{{ currentYear }}. All Rights Reserved
            </p>
          </div>
          <div class="col-md-6">
            <div class="d-flex align-items-center justify-content-md-end justify-content-center">
              <a href="/refund-policy" class="mb-0 me-3 text-gray-9">Refund Policy</a>
              <a href="/privacy-policy" class="mb-0 me-3 text-gray-9">Privacy Policy</a>
              <a href="/terms-and-conditions" class="text-gray-9">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- /Footer -->
</div>

<div class="media-icons">
  <a href="https://wa.me/918107011186" class="whatsap-icon" target="_blank"
    ><i class="fa-brands fa-whatsapp"></i
  ></a>
  <a href="mailto:support@avrhrms.com" class="mail-icon"><i class="fa-regular fa-envelope"></i></a>
  <!-- <a href='https://join.skype.com/invite/KqfsfMbmDu9a' class='skype-icon' target='_blank'><i
          class='fa-brands fa-skype'
        ></i></a> -->
</div>

<div class="back-to-top">
  <a class="back-to-top-icon align-items-center justify-content-center d-flex show" href="#top"
    ><i class="fa-solid fa-arrow-up"></i
  ></a>
</div>

<!-- Cursor -->
<div class="xb-cursor tx-js-cursor">
  <div class="xb-cursor-wrapper">
    <div class="xb-cursor--follower xb-js-follower"></div>
  </div>
</div>
<!-- /Cursor -->

<!--Start of Tawk.to Script-->
<!-- <script
  data-cfasync="false"
  src="assets/layout/assets/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"
></script> -->
<!-- <script>
  var Tawk_API = Tawk_API || {},
    Tawk_LoadStart = new Date()
  ;(function () {
    var s1 = document.createElement('script'),
      s0 = document.getElementsByTagName('script')[0]
    s1.async = true
    s1.src = 'https://embed.tawk.to/5d7c946e9f6b7a4457e1a16b/default'
    s1.charset = 'UTF-8'
    s1.setAttribute('crossorigin', '*')
    s0.parentNode.insertBefore(s1, s0)
  })()
</script> -->

<!--End of Tawk.to Script-->

<!-- Jquery JS -->
<!-- <script src="assets/layout/assets/js/jquery-3.7.1.min.js"></script> -->

<!-- Bootstrap JS -->
<!-- <script src="assets/layout/assets/js/bootstrap.bundle.min.js"></script> -->

<!-- Wow JS -->
<!-- <script src="assets/layout/assets/js/wow.min.js"></script> -->

<!-- MeanMenu Js -->
<!-- <script src="assets/layout/assets/js/jquery.meanmenu.min.js"></script> -->

<!-- Owl carousel -->
<!-- <script src="assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js"></script> -->

<!-- aos animation -->
<!-- <script src="assets/layout/assets/plugins/aos/aos.js"></script> -->

<!-- Swiper Js -->
<!-- <script src="assets/layout/assets/plugins/swiper/swiper-bundle.min.js"></script>
    <script src="assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js"></script> -->

<!-- Counter JS -->
<!-- <script src="assets/layout/assets/js/jquery.counterup.min.js"></script>
    <script src="assets/layout/assets/js/jquery.waypoints.min.js"></script> -->

<!-- cursor JS -->
<!-- <script src="assets/layout/assets/js/cursor.js"></script> -->

<!-- Script JS -->
<!-- <script src="assets/layout/assets/js/script.js"></script>
    <script src="assets/layout/assets/js/inquiry.js"></script> -->
